import { createClient } from "@supabase/supabase-js";
import { isSessionActive } from "./authStorage";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseServiceRoleKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;

const supabaseKey = supabaseServiceRoleKey || supabaseAnonKey;

export const supabaseKeyMode = supabaseServiceRoleKey ? "service_role" : "anon";

if (!supabaseUrl || !supabaseKey) {
  console.warn(
    "[supabase] Missing REACT_APP_SUPABASE_URL or a Supabase key (anon or service role).",
  );
}

if (supabaseServiceRoleKey && process.env.NODE_ENV !== "production") {
  console.warn(
    "[supabase] Using SERVICE ROLE key in browser — admin access; never deploy publicly.",
  );
}

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseKey)
  : null;

export function assertSupabaseAllowed() {
  if (!isSessionActive()) {
    throw new Error("Unauthorized — login required before accessing Supabase data.");
  }
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase is not configured.");
  }
}
